import React, { useRef } from "react";
import clsx from "clsx";
import type { CarConfigHighlightSection } from "../../../utils/types/SectionTypes";
import baseConfigStyles from "../Carconfig.module.scss";
import styles from "../common/navigation/Navigation.module.scss";
import Cta from "../common/header/Cta";
import Icon from "../../../../shared-components/css-modules/toyota/atoms/Icon";
import { type CarConfigDispatchType, useCarConfigSelector } from "../../../redux/store";
import { scrollToTarget } from "../../../../../../common-deprecated/utils/scrollUtils";
import { setActiveSection } from "../../../redux/slices/CarConfigNavigationSlice";
import Carousel from "../../../../shared-components/css-modules/toyota/vendor/carousel/Carousel";
import { ScrollMethod } from "../../../../../../common-deprecated/hooks/useScrollSnap";
import HighlightsNavigationButton from "./HighlightsNavigationButton";
import HighlightsHeroButton from "./HighlightsHeroButton";
import a11y from "../../../../shared-components/css-modules/toyota/utils/Accessibility.module.scss";
import { CarConfigLabel, useCarConfigLabel } from "../../../utils/labelUtils";
import { useDispatch } from "../../../../../../shared-logic/redux/store";

const HighlightsNavigation = (): JSX.Element => {
    const dispatch = useDispatch<CarConfigDispatchType>();
    const gradeFeatures = useCarConfigSelector((state) =>
        state.grades.items.find((grade) => grade.id === state.car.grade.id),
    )?.gradeFeatures.filter(({ valid }) => valid);

    const handleClick = (target: CarConfigHighlightSection): void => {
        dispatch(setActiveSection(target));
        scrollToTarget(target);
    };

    const navigationLabel = useCarConfigLabel("carConfigA11yNavHighlights");

    const navRef = useRef<HTMLDivElement>(null);

    return (
        <div className={clsx(styles.wrapper, styles.visible)}>
            <nav id="step-navigation" className={styles.nav} ref={navRef} aria-label={navigationLabel}>
                {!!gradeFeatures?.length && (
                    <Carousel>
                        <Carousel.Trigger direction="left" className={clsx(styles["scroll-indicator"], styles.left)}>
                            <Icon variant="chevron-left" sizing="md" aria-hidden="true" />
                            <span className={a11y["sr-only"]}>
                                <CarConfigLabel label="carConfigA11ySliderMoveStart" />
                            </span>
                        </Carousel.Trigger>
                        <Carousel.Track itemCount={gradeFeatures.length} scrollMethod={ScrollMethod.Full}>
                            <HighlightsHeroButton handleClick={handleClick} />
                            {gradeFeatures.map((gradeFeature, index) => (
                                <HighlightsNavigationButton
                                    key={gradeFeature.id}
                                    section={gradeFeature.id}
                                    name={gradeFeature.name}
                                    index={index}
                                    label={gradeFeature.name}
                                />
                            ))}
                        </Carousel.Track>
                        <Carousel.Trigger direction="right" className={clsx(styles["scroll-indicator"], styles.right)}>
                            <Icon variant="chevron-right" sizing="md" aria-hidden="true" />
                            <span className={a11y["sr-only"]}>
                                <CarConfigLabel label="carConfigA11ySliderMoveEnd" />
                            </span>
                        </Carousel.Trigger>
                    </Carousel>
                )}
            </nav>
            {/* info: Mobile CTAS, use same component but show hide via css */}
            <div className={baseConfigStyles.cta}>
                <Cta />
            </div>
        </div>
    );
};

export default HighlightsNavigation;
